import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import Stats from '../components/Stats';
import FounderStory from '../components/FounderStory';
import WhyGedik from '../components/WhyGedik';
import Services from '../components/Services';
import ProcessTimeline from '../components/ProcessTimeline';
import ProjectGallery from '../components/ProjectGallery';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import Newsletter from '../components/Newsletter';
import ContactForm from '../components/ContactForm';
import Footer from '../components/Footer';
import Chatbot from '../components/Chatbot';
import './LandingPage.css';

const LandingPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  return (
    <div className={`landing-page ${isLoaded ? 'loaded' : ''}`}>
      <Header />
      <Hero />
      <Stats />
      <FounderStory />
      <WhyGedik />
      <Services />
      <ProcessTimeline />
      <ProjectGallery />
      <Testimonials />
      <FAQ />
      <Newsletter />
      <ContactForm />
      <Footer />
      <Chatbot />
    </div>
  );
};

export default LandingPage;
